import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	state: null,
	error: "",
	loading: false,
};

// ADD_state
export const addState = createAsyncThunk(
	"state/addState",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `state/`,
				data: {
					...values,
				},
			});
			toast.success("State added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding State try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_state
export const deleteState = createAsyncThunk(
	"state/deleteState ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `state/${id}`,
			});

			toast.success("State deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting State try again");
			console.log(error.message);
		}
	}
);

// stateS
export const getAllState = createAsyncThunk(
	"state/getAllState",
	async () => {
		try {
			const { data } = await axios.get(`state/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateState = createAsyncThunk(
	"state/updateState",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `state/${id}`,
				data: {
					...values,
				},
			});
			toast.success("State updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating State try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const stateSlice = createSlice({
	name: "state",
	initialState,
	reducers: {
		clearState: (state) => {
			state.state = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllState ======

		builder.addCase(getAllState.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllState.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllState.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addState  ======

		builder.addCase(addState.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addState.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addState.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for state ======

		builder.addCase(updateState.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateState.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateState.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteState  ======

		builder.addCase(deleteState.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteState.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteState.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default stateSlice.reducer;
export const { clearState } = stateSlice.actions;
